import { AggregationType, Granularity, TimeRangeOption } from '../../types';
import { DataExportScope } from '../utils/combineDataExportUsage';
import { getSeriesTotal } from '../utils/getSeriesTotal';

import { useDataExportSourceUsage } from './useDataExportSourceUsage';
import { useUsageMonthOptions } from './useUsageMonthOptions';
import { useUsageTimestamps } from './useUsageTimestamps';

export function useDataExportCombinedMonthToDate({ enabled = true }: { enabled?: boolean } = {}) {
  const { today, defaultMonth } = useUsageMonthOptions();
  const timestamps = useUsageTimestamps({ timeRange: TimeRangeOption.MONTH_TO_DATE, month: defaultMonth, today });
  const sources = useDataExportSourceUsage({
    from: timestamps.from,
    to: timestamps.to,
    aggregationType: AggregationType.MONTH_TO_DATE,
    granularity: Granularity.DAILY,
    enabled,
  });
  const states = [sources[DataExportScope.STREAMING], sources[DataExportScope.WAREHOUSE]];

  return {
    isLoading: states.some(({ isLoading }) => isLoading),
    isError: states.some(({ isError }) => isError),
    total: states.reduce(
      (sum, { data }) =>
        sum +
        getSeriesTotal({
          series: data?.series,
          aggregationType: AggregationType.MONTH_TO_DATE,
          granularity: Granularity.DAILY,
        }),
      0,
    ),
  };
}
